export type OpenEditorType = "vscode" | "vscode-insiders" | "cursor";
export type VSCodeEditorArgs =
  | {
      type: "sandbox";
      id: string;
    }
  | {
      type: "branch";
      id: string;
    };

interface Args {
  editor: VSCodeEditorArgs;
  authToken: string | null;
  activeFilepath?: string | null;
  insiders?: boolean;
  type?: OpenEditorType;
}

function getExtensionUri({ editor, type }: Args): URL {
  const protocol = (type || "vscode") + ":";

  if (editor.type === "sandbox") {
    return new URL(
      `${protocol}//CodeSandbox-io.codesandbox-projects/sandbox/${editor.id}`,
    );
  } else {
    return new URL(
      `${protocol}//CodeSandbox-io.codesandbox-projects/branch/${editor.id}`,
    );
  }
}

export function buildExtensionUri(args: Args): URL {
  const { activeFilepath, authToken } = args;
  const extensionUri = getExtensionUri(args);

  if (authToken) {
    // Append the authentication token if present.
    // This allows for an auth-less sign in in the extension.
    extensionUri.searchParams.set("token", authToken);
  }

  if (activeFilepath) {
    extensionUri.searchParams.set("filepath", activeFilepath);
  }

  return extensionUri;
}
